import { Injectable } from '@angular/core';

import { ParticipantMarketType, ParticipantPriceStatus } from '@cds/betting-offer';
import { ForecastParticipantViewModel } from '@frontend/sports/racing/feature/models';

@Injectable({
    providedIn: 'root',
})
export class GreyhoundsPostPicksService {
    getMarketType(isTricastSelected?: boolean): ParticipantMarketType {
        return isTricastSelected ? ParticipantMarketType.Tricast : ParticipantMarketType.Forecast;
    }

    isOptionSuspended(participants: ForecastParticipantViewModel[], marketType: ParticipantMarketType): boolean {
        return participants
            .flatMap((p) => p.options)
            .filter((o) => o.marketType === marketType)
            .some((o) => o.participantPriceStatus === ParticipantPriceStatus.Suspended);
    }
}
